// extracted by mini-css-extract-plugin
export default {"imageContainer":"Carousel_imageContainer__ZlVST","carouselContainer":"Carousel_carouselContainer__EjYyM"};